import { withFormik } from "formik";
import * as Yup from "yup";

Yup.addMethod(Yup.mixed, "checkExt", function(messsage) {
  return this.test("checkExt", messsage, function(list) {
    const allowedExtensions = ["jpg", "jpeg", "png", "webp"];
    console.log("list", list);
    if (list) {
      if (list.name) {
        if (allowedExtensions.includes(list?.name?.split(".").pop())) {
          return true;
        } else {
          console.log("check here ");
          return false;
        }
      } else {
        if (allowedExtensions.includes(list.split(".").pop())) {
          return true;
        } else {
          return false;
        }
      }
    } else {
      return true;
    }
  });
});

const EditProfileEnhancer = withFormik({
  validationSchema: Yup.object().shape({
    name: Yup.string()
      .required("Please enter name")
      .matches(/^[a-zA-Z\s]+$/, "Name can only contain letters and spaces")
      .min(2, "Name must be at least 2 characters in length")
      .max(50, "Name must be at most 50 characters in length"),
    email: Yup.string()
      .email("The email you have entered is invalid")
      .max(60, "Max length of 60 characters")
      .trim()
      .required("Please enter email"),
    phone_number: Yup.string()
      .required("Please enter phone number")
      .matches(/^[0-9]+$/, "Please enter a valid  phone number"),
    file_image: Yup.mixed()
      .checkExt(
        "Invalid file format please upload file within specified formats"
      )
      .nullable()
  }),
  mapPropsToValues: props => ({
    name: "",
    email: "",
    phone_number: "",
    file_image: ""
  }),

  handleSubmit: values => {},
  validateOnMount: true,
  displayName: "CustomValidationForm",
  enableReinitialize: true
});

export default EditProfileEnhancer;
